import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const UtilizacionAlmacenRadar = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getWarehouseUtilization, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getWarehouseUtilization() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Retail', 'Automotriz', 'Manufactura', 'Alimentos', 'Sector salud/ Farmacéuticas', 'Construcción', 'Servicios Logísticos'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [85, 88, 87, 86, 78, 80, 70];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [91, 91, 90, 89, 81, 81, 71];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [86, 93, 88, 89, 70, 93, 91];

  const chartData = {
    labels: allLabels,
    datasets: [
      {
        label: '2023',
        data: allData2022,
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: allData2023,
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: allData2024,
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value) => `${value}%`,
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
          font: {
            size: 12,
          },
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
        title: {
          display: true,
          text: 'Porcentaje (%)',
          font: {
            size: 12,
          },
        },
      },
    },
  };

  const infoContent = {
    formula: 'Utilización del Almacén (%) = (Espacio utilizado / Espacio total disponible) × 100',
    description: 'Mide la capacidad utilizada del almacén.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmula:</strong> {infoContent.formula}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default UtilizacionAlmacenRadar;
